// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { memo } from 'react'
import { BrowserRouter } from 'react-router-dom'
import SubRoute from './router/SubRoute'
import StoreProvider from '@/store/StoreProvider'
import GlobalLoading from '@/components/GlobalLoading/GlobalLoading'
import GlobalLoginModal from '@/components/GlobalLoginModal/GlobalLoginModal'
import GlobalPayCenter from '@/components/GlobalPayCenter/GlobalPayCenter'
import GlobalPlatformModal from '@/components/GlobalPlatformModal/GlobalPlatformModal'
import * as Sentry from '@sentry/react'
import ErrorFallback from '@/components/ErrorFallback/ErrorFallback'
import { App } from 'antd'

// const unityUrl = process.env.VITE_NAME
// import eruda from 'eruda'
// if (process.env.VITE_NAME === 'chatdev') {
// eruda.init()
// }
const Root = () => {
  return (
    <App>
      <Sentry.ErrorBoundary
        fallback={({ error, componentStack, eventId, resetError }) => (
          <ErrorFallback error={error} componentStack={componentStack} eventId={eventId} resetError={resetError} />
        )}
      >
        <StoreProvider>
          <BrowserRouter>
            <SubRoute />
            <GlobalLoading />
            <GlobalLoginModal />
            <GlobalPayCenter />
            <GlobalPlatformModal />
          </BrowserRouter>
        </StoreProvider>
      </Sentry.ErrorBoundary>
    </App>
  )
}

export default memo(Root)
